import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Plus, XCircle } from "lucide-react";

export function DropdownOptionsDialog({
  editingDropdown, setEditingDropdown, dropdownOptions,
  newOptionValue, setNewOptionValue,
  addDropdownOption, removeDropdownOption,
}) {
  return (
    <Dialog open={!!editingDropdown} onOpenChange={() => { setEditingDropdown(null); setNewOptionValue(""); }}>
      <DialogContent className="max-w-md rounded-3xl">
        <DialogHeader>
          <DialogTitle>Manage {editingDropdown === "subjects" ? "Subjects" : "Class Levels"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex gap-2">
            <Input
              value={newOptionValue}
              onChange={e => setNewOptionValue(e.target.value)}
              placeholder={`Add new ${editingDropdown === "subjects" ? "subject" : "class level"}...`}
              className="rounded-xl"
              onKeyDown={e => e.key === "Enter" && editingDropdown && addDropdownOption(editingDropdown)}
              data-testid="dropdown-new-input"
            />
            <Button onClick={() => editingDropdown && addDropdownOption(editingDropdown)} className="rounded-xl shrink-0" data-testid="dropdown-add-btn">
              <Plus className="w-4 h-4" />
            </Button>
          </div>
          <div className="space-y-1.5 max-h-60 overflow-y-auto">
            {editingDropdown && (dropdownOptions[editingDropdown] || []).map(opt => (
              <div key={opt} className="flex items-center justify-between bg-gray-50 rounded-xl px-4 py-2.5">
                <span className="text-sm font-medium">{opt}</span>
                <button
                  onClick={() => removeDropdownOption(editingDropdown, opt)}
                  className="text-gray-400 hover:text-red-500 transition-colors"
                  data-testid={`remove-${opt}`}
                >
                  <XCircle className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
